import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Home extends Component {
    render() {
        return (
            <div>
                <hr />
                {/* About Section */}
                <section className="section about-page py-5">
                    <div className="container text-center">
                        <div className="row align-items-center">
                            <div className="col-lg-4 mb-4 d-flex justify-content-center justify-content-lg-start">
                                <img src="images/home/home_1.png" alt="Bhoomi Rocks Products" className="img-fluid rounded shadow" />
                            </div>
                            <div className="col-lg-8">
                                <h2 className="title-color">Welcome to Bhoomi Rocks Products</h2>
                                <p className="mt-3">
                                    Established on May 22, 2023, in Bengaluru, India, Bhoomi Rocks Products is a premier partnership firm dedicated to prospecting, exploring, and processing high-quality natural stones, minerals, and allied materials. Led by our Managing Partner, Deepika B, we specialize in sourcing, manufacturing, and distributing premium rocks for construction, landscaping, and decorative purposes.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Our Process */}
                <section className="section bg-light py-5">
                    <div className="container text-center">
                        <h2 className="mb-5">Our Process</h2>
                        <div className="row">
                            {[
                                { icon: '🪨', title: '1. Source', desc: 'We prospect and source premium natural stones and minerals from trusted quarries across India.' },
                                { icon: '🔍', title: '2. Inspect & Process', desc: 'Each stone is meticulously inspected, processed, and manufactured to meet stringent quality standards.' },
                                { icon: '🚚', title: '3. Deliver', desc: 'We ensure fast, safe, and reliable delivery to your location, anywhere in India.' },
                                { icon: '🏡', title: '4. Transform', desc: 'Transform your spaces with our durable, high-quality stones for construction and decoration.' }
                            ].map((step, idx) => (
                                <div key={idx} className="col-md-3 mb-4">
                                    <div className="p-4 border rounded shadow-sm h-100">
                                        <div style={{ fontSize: '36px' }}>{step.icon}</div>
                                        <h5 className="mt-3">{step.title}</h5>
                                        <p className="text-muted">{step.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Call to Action */}
                <section className="section text-center py-5">
                    <div className="container">
                        <h2 className="mb-4">Start Your Project with Bhoomi Rocks Products</h2>
                        <p className="mb-4">Partner with us to access top-quality stones and minerals for your construction and landscaping needs. Contact us to explore our offerings and start your project today!</p>
                        <Link to="/contact" className="btn btn-main btn-round-full mx-2">Get in Touch</Link>
                        <Link to="/products" className="btn btn-main btn-round-full mx-2" style={{ background: "black" }}>Explore Products</Link>
                    </div>
                </section>
            </div>
        );
    }
}